import React from 'react';
import { Modal, Box, Typography, Button, Grid, makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(() => ({
    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        backgroundColor: '#fff',
        borderRadius: '16px',
        boxShadow: 24,
        padding: 32,
        textAlign: 'center',
        outline: 'none',
    },
    icon: {
        color: '#008002',
        fontSize: 72,
        marginBottom: 16,
        marginTop: 16,
    },
    title: {
        fontWeight: 700,
        marginBottom: 14,
    },
    message: {
        marginBottom: 26,
        color: '#444',
        fontSize: 16,
    },
    gridContainer: {
        marginBottom: 24,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 20,
    },
    gridItem: {
        maxWidth: 200,
    },
    label: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    value: {
        fontSize: 14,
        marginBottom: 24,
    },
    button: {
        position: 'relative',
        padding: '5px 5px',
        backgroundColor: '#FF6B35',
        borderRadius: '999px',
        width: 150,
        textTransform: 'none',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#c6532b',
        },
    },
    buttonText: {
        fontSize: 16,
        fontWeight: 500,
        width: '100%',
    },
    iconChevron: {
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: 20,
    },
}));


export default function UploadDetailsSavedDialog({ open, onClose, added = 0, updated = 0 }) {
    const classes = useStyles();

    // Reflect what actually happened rather than always showing "added/updated".
    // Falls back to "saved" when neither count is known (e.g. only the
    // project/campaign/material sections were submitted — the backend doesn't
    // report add vs update for those).
    const actionText =
        added > 0 && updated > 0
            ? "added and updated"
            : updated > 0
                ? "updated"
                : added > 0
                    ? "added"
                    : "saved";

    return (
        <Modal open={open} onClose={onClose}>
            <Box className={classes.modalBox}>
                <CheckCircleIcon className={classes.icon} />

                <Typography variant="h5" className={classes.title}>
                    Details Saved Successfully
                </Typography>

                <Box>
                    <Typography className={classes.message}>
                        Your records have been {actionText}.<br />
                        Please contact admin if you have entered the wrong data.
                    </Typography>
                </Box>


                <Button variant="contained" onClick={onClose} className={classes.button}>
                    <Typography align="center" className={classes.buttonText}>
                        OK
                    </Typography>
                    <ChevronRightIcon className={classes.iconChevron} />
                </Button>
            </Box>
        </Modal>
    );
}
